const groupOption = function () {
  return {
    labelWidth: 100,
    emptyBtn: false,
    submitBtn: false,
    labelPosition: "left",
    column: [
      {
        label: "名称",
        span: 24,
        prop: "name",
        // disabled: true,
        rules: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change"
          }
        ]
      },
      {
        label: "负责人",
        span: 24,
        prop: "chargePerson",
        formslot: true,
        // disabled: true,
        rules: [
          {
            required: true,
            message: "请选择负责人",
            trigger: "change"
          }
        ]
      }
      // {
      //   label: "访客有车",
      //   span: 24,
      //   prop: "appointmentCarNotifyFlag",
      //   formslot: true,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请选择",
      //       trigger: "change"
      //     }
      //   ]
      // },
      // {
      //   label: "访客无车",
      //   span: 24,
      //   prop: "appointmentNoCarNotifyFlag",
      //   formslot: true,
      //   rules: [
      //     {
      //       required: true,
      //       message: "请选择",
      //       trigger: "change"
      //     }
      //   ]
      // },
      ,{
        label: "负责管辖区域",
        span: 24,
        prop: "region",
        formslot: true
      }
    ]
  };
};

export default groupOption;
